import { get } from "lodash";
import api from "../../app/api";

export interface ILoginRequest {
  username: string;
  password: string;
}

export interface IAuthLogRequest {
  reason: string;
  status: string;
  action: string;
  created_by: number;
}

const login = (payload: ILoginRequest) => {
  return api.post("/auth/authenticate.php", {
    username: payload.username,
    password: payload.password,
  });
};

const addAuthLog = (payload: IAuthLogRequest) => {
  return api.post("/auth_logs/addAuthLog.php", {
    reason: payload.reason,
    status: payload.status,
    action: payload.action,
    created_by: payload.created_by,
  });
};

const getAuthLog = (payload: { page: number }) => {
  return api.post("/auth_logs/getAuthLog.php", {
    page: payload.page
  });
};

const LoginApi = {
  login,
  addAuthLog,
  getAuthLog
};

export default LoginApi;
